import Vue from 'vue'

export default {
  state: {
    // Conservé pour la compatibilité mais plus utilisé
    queue: []
  },
  mutations: {
    // Conservé pour la compatibilité
    addNotification (state, notification) {
      state.queue = [notification, ...state.queue]
    },
    removeNotification (state, notification) {
      state.queue = state.queue.filter(notif => notif.id !== notification.id)
    }
  },
  actions: {
    addNotification ({ commit }, notification) {
      // Utilisation de vue-toastification au lieu du système précédent
      const { text, message, color = 'info' } = notification
      const toastText = text || message
      
      // Mapping des couleurs vers les types de toast
      const typeMapping = {
        success: 'success',
        green: 'success',
        error: 'error',
        red: 'error',
        warning: 'warning',
        orange: 'warning',
        info: 'info',
        blue: 'info',
        default: 'info'
      }
      
      const toastType = typeMapping[color] || typeMapping.default
      
      // Affichage du toast
      Vue.$toast[toastType](toastText, {
        timeout: 3000,
        icon: {
          success: 'check_circle',
          error: 'error',
          warning: 'warning',
          info: 'info'
        }[toastType]
      })
      
      // Conservé pour la compatibilité si nécessaire
      commit('addNotification', { ...notification, id: Date.now() })
    },
    removeNotification ({ commit }, notification) {
      commit('removeNotification', notification)
    }
  }
}
